<template>
    <div>
         <loading :active.sync="isLoading" 
                    :can-cancel="true" 
                    :is-full-page="fullPage"></loading>
        
        <a-modal :closable="false"
            width="100%"
            :visible="isVisible"
			:dialog-style="{ top: '10px' }"
        >
            <template #footer>

				<a-button @click="handleBtnCancel">
					Cancel
				</a-button>

				<a-button type="primary" @click="handleBtnSave" :disabled="cart.length <= 0">
					Save
				</a-button>

			</template>

            <div v-show="step==0">
                <a-row :gutter="24" type="flex" align="stretch" class="header-solid h-full mb-24 category-infinite-container" >
                    <a-col :span="24" :lg="24" >
                        <repository-tabs-view />
                    </a-col>
                </a-row>
                <br/>
                <div>
                    <a-row type="flex" :gutter="24">
                        <a-col :span="16" :lg="16" class="mb-24">
                            <h6>Total Items: {{ totalItems }} - Amount : {{ amount }}</h6>
                        	<a-card :bordered="false" 
                                    class="header-solid h-full mb-24 demo-infinite-container" 
                                    :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                                    :span="18" :lg="18" v-infinite-scroll="handleInfiniteOnload"
                                    :infinite-scroll-disabled="busy"
                            >
                                <items-in-cart-table-view />
                            </a-card>
                        </a-col>
                        <a-col :span="8" :lg="8" >
                            <order-information-form-view />
                        </a-col>
                   </a-row>
                </div>
            </div>
        </a-modal> 
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters, mapState } from 'vuex'
import InfiniteScroll from 'v-infinite-scroll'
import RepositoryTabsView from './RepositoryTabsView.vue'
import ItemsInCartTableView from './ItemsInCartTableView.vue'
import OrderInformationFormView from './OrderInformationFormView.vue'



export default {
    directives: { InfiniteScroll },
    inject : ['eventBus'],
    components : {
       RepositoryTabsView,
       ItemsInCartTableView,
       OrderInformationFormView,
       Loading
    },

    computed : {
       
        ...mapState({
            categories : state => state.phoneService.categoriesFromProductsList,
            products : state => state.phoneService.products,
            currentWaitingTime : state => state.phoneService.orderManager.currentWaitingTime,
            cart : state => state.ordering.cart,
        }),
        ...mapGetters({ 
            productsByCategoryId : 'phoneService/productsByCategoryId',
            totalItems : 'ordering/totalItems',
            amount: 'ordering/amount'
        }),
        
    },
    data () {
        
        return {
            //
            //config data
            //
            isVisible : false,
            busy: false,
            step : 0,
            onTheSameTransaction : false,
            isLoading : false,
            fullPage : true,
        }
    },

    methods : {
       
        async showModal() {
            this.resetModal();

            let restaurantId = this.$store.state.phoneService.selectedRestaurantId;
            await this.$store.dispatch('phoneService/getProductsAction', { });
            await this.$store.dispatch('phoneService/getCategoriesAction', { });
            await this.$store.dispatch('phoneService/getTaxesAction', { });

            await this.$store.dispatch('openingHours/getCurrentOpeningTimeAction', {});
            await this.$store.dispatch('ordering/getPickupNumberAction', {"restaurantId" : restaurantId});

            await this.$store.dispatch('phoneService/getOrderManagerStateAction', {})
            await this.$store.dispatch('openingHours/getCurrentLocalTimeAction', {});

            let maxTime = this.$store.state.phoneService.orderManagerState.maxWaitingTime;
            let currentWaitingTime = this.$store.state.phoneService.orderManagerState.currentWaitingTime;
            this.$store.commit('ordering/UPDATE_ESTIMATED_PICKUP_TIME_STATE', {'minWaitingTime' : currentWaitingTime, 'maxWaitingTime' : maxTime });
            this.$store.commit('ordering/CHANGE_PICKUP_TIME_STATE', this.$store.getters['ordering/initPickupTime'] );
            this.isVisible = true;
            this.$message.destroy();
            
        },

        async handleBtnSave() {
            this.isLoading = true;
            let restaurantId = this.$store.state.phoneService.selectedRestaurantId;
            await this.$store.dispatch('ordering/createOrderByPhoneAction', {"restaurantId" : restaurantId});
            this.isLoading = false;
            this.isVisible = false;
            this.resetModal();
        },

        handleBtnCancel() {
            this.isVisible = false;
            this.resetModal();
        },

        async handleBtnNext() {
            this.step = 1;
            this.isLoading = true;
            let restaurantId = this.$store.state.phoneService.selectedRestaurantId;
             if(!this.onTheSameTransaction) {
                await this.$store.dispatch('openingHours/getCurrentOpeningTimeAction', {});
                await this.$store.dispatch('ordering/getPickupNumberAction', {"restaurantId" : restaurantId});
                this.onTheSameTransaction = true;
            }

            await this.$store.dispatch('phoneService/getOrderManagerStateAction', {})
            await this.$store.dispatch('openingHours/getCurrentLocalTimeAction', {});
            //
            //recalculate estimated time based on currentWaiting Time and Max waiting Time
            //
            let minTime = this.$store.state.phoneService.orderManagerState.currentWaitingTime;
            let maxTime = this.$store.state.phoneService.orderManagerState.maxWaitingTime;
            this.$store.commit('ordering/UPDATE_ESTIMATED_TIME', {'minWaitingTime' : minTime, 'maxWaitingTime' : maxTime});

            //
            //recalculate pickup time
            //
            this.$store.commit('ordering/CHANGE_PICKUP_TIME_STATE', this.$store.getters['ordering/initPickupTime'] );

            this.isLoading = false;
        },
        handleBtnBack() {
            this.step = 0;
        },
        resetModal() {
            this.onTheSameTransaction = false;
            this.$store.commit('ordering/RESET_STATE', {});
            this.step = 0;
        },
        handleInfiniteOnload() {
        },
        
    },
}

</script>

<style lang="scss">
	.full-modal {
  		.ant-modal {
    		max-width: 100%;
    		top: 0;
    		padding-bottom: 100;
    		margin: 0;
  		}
  		.ant-modal-content {
    		display: flex;
    		flex-direction: column;
    		height: calc(100vh);
  		}
  		.ant-modal-body {
    		flex: 1;
  		}
	}

    .category-button {
        padding: 5px;
        margin: 5px;
    }

    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 8px 24px;
        height: 320px;
        width : 100%;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
    .category-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 8px 24px;
        height: 220px;
        width : 100%;
    }

    .customer-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 8px 24px;
        height: 350px;
        width : 100%;
    }
</style>